module.exports = __webpack_public_path__ + "img/4.f028d652.png";